@let isExpanded = expanded();

<div
  class="search-input"
  [class.is-expanded]="isExpanded"
  [ngClass]="sizeClass()"
  [style.pointer-events]="isExpanded ? 'none' : 'auto'"
  [style.height]="sizeValue()"
  [style.width]="isExpanded ? 'fit-content' : sizeValue()"
  (click)="isExpanded ? null : expandControl($event)">
  @if (isExpanded) {
    <input
      #searchInput
      [formControl]="ngControl.control"
      [placeholder]="placeholder()" />
  }

  <topo-icon
    class="search-icon"
    [class.is-button]="!isExpanded"
    [props]="{ type: 'system', path: 'icon-search' }"
    (click)="isExpanded ? null : onSearchClicked.emit(ngControl.control.value)" />

  @if (isExpanded) {
    <div class="vertical-divider"></div>
    <topo-icon
      [props]="{ type: 'system', path: 'icon-close-X' }"
      (click)="collapseControl($event)" />
  }
</div>
